// SQL 의 bind 변수(:name) 이름을 추출. 라인/블록 코멘트, 단일 따옴표 문자열은
// 미리 제거해 false-positive 회피. 백엔드 monitoringRouter 의 동명 함수와 동일 로직.
export function extractBindNames(sql) {
  if (!sql) return [];
  const stripped = String(sql)
    .replace(/--[^\n]*/g, ' ')
    .replace(/\/\*[\s\S]*?\*\//g, ' ')
    .replace(/'(?:''|[^'])*'/g, "''");
  const names = new Set();
  const re = /:([a-zA-Z_][a-zA-Z0-9_]*)/g;
  let m;
  while ((m = re.exec(stripped)) !== null) names.add(m[1]);
  return [...names];
}

// 시스템이 자동 공급하는 bind 이름 — 사용자 변수와 구분하기 위함.
// inst_no — 대시보드의 노드 고르기(0 = 합계, 2026-10-16). 서버가 채우므로 패널이 기다릴 변수가 아니다
export const SYSTEM_BINDS = new Set(['minutes', 'hours', 'inst_no']);

// 패널이 SQL 에서 요구하는 "사용자 변수" 이름 (system bind 제외).
// PanelTabContent 가 이 목록과 tabVariables 를 비교해 placeholder 표시 여부 결정.
export function getRequiredVariables(sql) {
  return extractBindNames(sql).filter(n => !SYSTEM_BINDS.has(n));
}
